import React, { useState, useContext, useEffect} from 'react';

import PropTypes from 'prop-types';

import './VettingPostalAddress.css';

import VettingDropDown from '../../Common/VettingDropDown/VettingDropDown';
import VettingInput from '../../Common/VettingInput/VettingInput';
import KeyValueDataComponent from '../KeyValueDataComponent/KeyValueDataComponent';
import VettingCheckBoxPanel from '../../Common/VettingCheckBoxPanel/VettingCheckBoxPanel';
import VettingSearchBar from '../../Common/VettingSearchBar/VettingSearchBar';

import {
  SalesContext
} from "../../../Context/SalesContext";
import {
  FormFieldLabel
} from '../../../StyledComponents';
import {
  checkInputValidity,
  getKeyValueData,
  createArray,
  getDetailedAddressObject,
  getKeyValueDataFromAddressobj,
  registerEnterEvent
} from '../../../Utility/utility';

const VettingPostalAddress = (props) => {
  const context = useContext(SalesContext);
  const postalAddress = context.vettingCreditDetails.postalAddress;
  const provinceList = context.provinceList;
  const homeAddress = context.vettingCreditDetails.homeAddress;

  const [sameAsHomeAddress, setSameAsHomeAddress] = useState(context.vettingSameAsHomeAddress);
  const [newPostalAddress, setNewPostalAddress] = useState(homeAddress);
  const [reverseGeoCodeError, setReverseGeoCodeError] = useState(null);

  const [formData, setFormData] = useState({
    // Form Fields
    formComponents: {
      searchBar: {
        name: "Search Address",
        type: "search",
        value: postalAddress?.searchBar?.value || homeAddress?.searchBar?.value || "",
        width: 100,
        validations: {
          required: false,
          invalidMessage: "",
        },
        config: {
          type: "search",
          required: false,
          placeholder: "Search address",
          tabIndex: "41"
        },
        isValid: true,
        isTouched: true
      },
      unitNumber: {
        name: "Unit no.",
        type: "input",
        optional: true,
        value: postalAddress?.unitNumber?.value || homeAddress?.unitNumber?.value || "",
        width: 30,
        validations: {
          required: false,
          invalidMessage: "Please enter a valid cell phone number",
        },
        config: {
          type: "text",
          required: true,
          placeholder: "0000",
          tabIndex: "42"
        },
        isValid: true,
        isTouched: true
      },
      buildingName: {
        name: "Building name",
        type: "input",
        optional: true,
        value: postalAddress?.buildingName?.value || homeAddress?.buildingName?.value || "",
        width: 65,
        validations: {
          required: false,
          invalidMessage: "Please enter a valid building name address",
        },
        config: {
          type: "text",
          required: true,
          placeholder: "Enter complex name",
          tabIndex: "43",
          maxLength: 30
        },
        isValid: true,
        isTouched: true
      },
      streetNo: {
        name: "Street no.",
        type: "input",
        value: postalAddress?.streetNo?.value || homeAddress?.streetNo?.value || "",
        width: 30,
        validations: {
          required: true,
          invalidMessage: "Please enter your street number",
        },
        config: {
          type: "text",
          required: true,
          placeholder: "Street no.",
          tabIndex: "45"
        },
        isValid: false,
        isTouched: false
      },
      streetName: {
        name: "Street name",
        type: "input",
        value: postalAddress?.streetName?.value || homeAddress?.streetName?.value || "",
        width: 65,
        validations: {
          required: true,
          invalidMessage: "Please enter your street name",
        },
        config: {
          type: "text",
          required: true,
          placeholder: "Enter street name",
          tabIndex: "46"
        },
        isValid: false,
        isTouched: false
      },
      suburb: {
        name: "Suburb",
        type: "input",
        value: postalAddress?.suburb?.value || homeAddress?.suburb?.value || "",
        width: 65,
        validations: {
          required: true,
          invalidMessage: "Please enter your suburb",
        },
        config: {
          type: "text",
          required: true,
          placeholder: "Enter Suburb",
          tabIndex: "47"
        },
        isValid: false,
        isTouched: false
      },
      postalCode: {
        name: "Postal code",
        type: "input",
        value: postalAddress?.postalCode?.value || homeAddress?.postalCode?.value || "",
        width: 30,
        validations: {
          required: true,
          type: "number",
          minLength: 4,
          maxLength: 5,
          invalidMessage: "Please enter valid postal code",
        },
        config: {
          type: "text",
          required: true,
          placeholder: "Postal code",
          tabIndex: "48"
        },
        isValid: false,
        isTouched: false
      },
      town: {
        name: "Town/City",
        type: "input",
        value: postalAddress?.town?.value || homeAddress?.town?.value || "",
        width: 100,
        validations: {
          required: true,
          invalidMessage: "Please enter your town/city",
        },
        config: {
          type: "text",
          required: true,
          placeholder: "Enter town/city",
          tabIndex: "49"
        },
        isValid: false,
        isTouched: false
      },
      province: {
        name: "Province",
        type: "dropDown",
        value: postalAddress?.province?.value || homeAddress?.province?.value || "",
        options: provinceList,
        width: 100,
        validations: {
          required: true,
          invalidMessage: "Please select your province",
        },
        config: {
          type: "select",
          required: true,
          placeholder: "Select province",
          tabIndex: "50"
        },
        isValid: false,
        isTouched: false
      },
    },
    isFormValid: false
  });

  // Create array
  const formCompArray = createArray(formData.formComponents);
  registerEnterEvent();

  const formComponentChangeHandler = (event, inputIdentifier) => {
    const formCompsCopy = { ...formData.formComponents };
    const changedComponent = { ...formCompsCopy[inputIdentifier] };
    changedComponent.value = event;
    if (changedComponent.validations.type === "number") {
      let lastChar = changedComponent.value.slice(-1);
      if (isNaN(lastChar)) {
        return false;
      }
    }

    changedComponent.isValid = checkInputValidity(
      changedComponent.value,
      changedComponent.validations
    );

    changedComponent.isTouched = true;
    const changedComponent2 = { ...formCompsCopy['searchBar'] };
    if (inputIdentifier !== 'searchBar'
      && inputIdentifier !== 'unitNumber'
      && inputIdentifier !== 'buildingName'
    ) {
      changedComponent2.value = "";
    }

    if (inputIdentifier === "country" && event.toLowerCase() !== "south africa") {
      formCompsCopy['province'].type = "input";
      formCompsCopy['province'].config.type = "text"
    } else {
      formCompsCopy['province'].type = "dropDown";
      formCompsCopy['province'].config.type = "select"
    }

    const newFormComps = {
      ...formCompsCopy,
      [inputIdentifier]: changedComponent,
      searchBar: inputIdentifier === 'searchBar' ? changedComponent : changedComponent2
    }

    const isFormValid = !Object.keys(newFormComps).find(e => newFormComps[e].isValid === false) ? true : false;

    setFormData({
      formComponents: newFormComps,
      isFormValid: isFormValid
    });

    if (isFormValid) {
      props.toggleNext(true);
    } else {
      props.toggleNext(false);
    }
  };

  const saveDetails = () => {
    let keyValueData;
    if (sameAsHomeAddress) {
      keyValueData = homeAddress;
    } else {
      keyValueData = getKeyValueData(formData.formComponents);
    }
    context.setVettingDetails('postalAddress', keyValueData);
    props.onNextClick(keyValueData);
  }

  const updateNewPostalAddress = (address) => {
    formComponentChangeHandler(address, 'searchBar');
    context.setShowSpinner(true);
    getDetailedAddressObject(address)
      .then(res => {
        setNewPostalAddress(getKeyValueDataFromAddressobj(res));
        context.setShowSpinner(false);
        setReverseGeoCodeError(null);
      })
      .catch(_err => {
        setNewPostalAddress(null);
        context.setShowSpinner(false);
        setReverseGeoCodeError("Unable to pre-populate the vaules please enter manually.");
      })
  }

  useEffect(() => {
    const formCompsCopy = { ...formData.formComponents };
    for (let key in newPostalAddress) {
      if (newPostalAddress[key] === "")
        continue;

      const changedComponent = { ...formCompsCopy[key] };
      if (Object.keys(changedComponent).length !== 0) {
        changedComponent.value = newPostalAddress[key].value;

        changedComponent.isValid = checkInputValidity(
          changedComponent.value,
          changedComponent.validations
        );

        changedComponent.isTouched = true;

        formCompsCopy[key] = changedComponent;
      }
    }

    if (newPostalAddress && newPostalAddress['country']?.value.toLowerCase() !== "south africa") {
      formCompsCopy['province'].type = "input";
      formCompsCopy['province'].config.type = "text"
    } else {
      formCompsCopy['province'].type = "dropDown";
      formCompsCopy['province'].config.type = "select"
    }

    const isFormValid = !Object.keys(formCompsCopy).find(e => formCompsCopy[e].isValid === false) ? true : false;
    setFormData({
      formComponents: formCompsCopy,
      isFormValid: isFormValid
    });

    if(sameAsHomeAddress){
      props.toggleNext(true);
    }else{
      if (isFormValid) {
        props.toggleNext(true);
      } else {
        props.toggleNext(false);
      }
    }
  }, [newPostalAddress, props.isEditModeOn])

  return(
    <React.Fragment>
      <div className="vetting-main-section-wrapper">
        {
          postalAddress && !props.isEditModeOn ?
            <KeyValueDataComponent data={postalAddress} />
            :
            <React.Fragment>
              <VettingCheckBoxPanel
                value={sameAsHomeAddress}
                label={`
                  <div>My postal address is the same as my <span class="bold-font">Home address</span></div>
                `}
                inputIdentifier={'postalAddress'}
                onChange={(value) => {
                  setSameAsHomeAddress(value);
                  context.setVettingSameAsHomeAddress(value);
                  if (value) {
                    props.toggleNext(value);
                  }
                }}
              />
              <div className="vetting-pd-wrapper" style={{ marginTop: "2em" }}>
                {
                  !sameAsHomeAddress && formCompArray.map(item => {
                    return (
                      <div className={`input-field-wrapper-${item.config.width}`} key={item.key}>
                        {
                          item.config.type === "search" ?
                            formData?.formComponents?.country?.value?.toLowerCase() === "south africa" ?
                              <FormFieldLabel
                                hide={item?.config?.hideLabel}
                                automationidattr={`homeAddress${item.config.name}`}
                              >
                                {item.config.name}
                                {
                                  item?.config?.optional && <span className="vetting-optional-text"> (Optional)</span>
                                }
                              </FormFieldLabel>
                              :
                              // Revert if country scenario back
                              <FormFieldLabel
                                hide={item?.config?.hideLabel}
                                automationidattr={`homeAddress${item.config.name}`}
                              >
                                {item.config.name}
                                {
                                  item?.config?.optional && <span className="vetting-optional-text"> (Optional)</span>
                                }
                              </FormFieldLabel>
                            :
                            <FormFieldLabel
                              hide={item?.config?.hideLabel}
                              automationidattr={`homeAddress${item.config.name}`}
                            >
                              {item.config.name}
                              {
                                item?.config?.optional && <span className="vetting-optional-text"> (Optional)</span>
                              }
                            </FormFieldLabel>
                        }

                        {
                          item.config.type === "input" ?
                            <VettingInput
                              {...item.config}
                              updateValue={formComponentChangeHandler}
                              inputIdentifier={item.key}
                              automationidattr={`postalAddress`}
                            />
                            :
                            null
                        }
                        {
                          item.config.type === "dropDown" ?
                            <VettingDropDown
                              selectedValue={item.config.value}
                              placeholder={item.config.config.placeholder}
                              options={item.config.options}
                              updateSelectedOption={formComponentChangeHandler}
                              inputIdentifier={item.key}
                              automationidattr={`postalAddress`}
                            />
                            :
                            null
                        }
                        {
                          (item.config.type === "search") ?
                            <VettingSearchBar
                              value={item.config.value}
                              inputIdentifier={item.key}
                              updateValue={formComponentChangeHandler}
                              onAddressSelection={updateNewPostalAddress}
                              automationidattr={`postalAddress`}
                              errorMsg={reverseGeoCodeError}
                            />
                            :
                            null
                        }
                      </div>
                    )
                  })
                }
              </div>
              {
                props.showBody ?
                  <div className="vetting-next-wrapper">
                    <button
                      className={`vetting-section-next-button ${props.enableNext ? 'next-enabled' : ''}`}
                      onClick={() => saveDetails()}
                      disabled={props.enableNext ? '' : 'disabled'}
                      automationid={`SalesLead_button_postalAddressNextBtn_1"`}
                    >
                      Next
                    </button>
                  </div>
                  :
                  null
              }
            </React.Fragment>
        }
      </div>

    </React.Fragment>
  )
}

VettingPostalAddress.propTypes = {
  enableNext: PropTypes.bool,
  isEditModeOn: PropTypes.bool,
  onNextClick: PropTypes.func,
  showBody: PropTypes.bool,
  toggleNext: PropTypes.func,
}

export default VettingPostalAddress;